import { IconButton } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { styles } from "./CarouselNavButton.styles"

const CarouselNavButton = ({ direction = "right", onClick, label }) => {
  const isLeft = direction === "left"

  return (
    <IconButton
      onClick={onClick}
      sx={styles.navButton}
      size="small"
      aria-label={label}
    >
      {isLeft ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </IconButton>
  )
}

export default CarouselNavButton
